module.exports = __webpack_public_path__ + "img/img-3-13.b85f8d93.webp";